import { ThreeView } from "../View3dWebCad";
import { FloorItemOverControls } from '../controls/FloorItemOverControls';
import { defines } from "../../base";
import { itemLoader } from "./itemLoader";
import { ObjectType } from '../ObjectType';

export class AddFloorItemLoader extends itemLoader {

    private controller: FloorItemOverControls;

    // itemId is white model
    constructor(itemId: string, index: string) {
        super(itemId, index);
    }

    protected createController(object: THREE.Object3D) {
        const camera = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        const element = ThreeView.get().wcRenderer.me.domElement;
        this.controller = new FloorItemOverControls([object], camera.me, element);
        object.visible = false;
    }

    protected removeController() {
        this.controller.dispose();
        this.controller = undefined;
    }

    // 配置場所判定
    protected location(e): boolean {
        const hitObj = ThreeView.get().selectManager.hitObjects(e);

        if (hitObj.length < 1) return;

        return (ObjectType.isFloor(hitObj[0].object) && ObjectType.isFloor_(hitObj[0].object));
    }

}
